import { Skeleton } from '@fe-learner-common';
import { useConfigContext } from '@fe-core';

const BradcrumbSkeleton = () => (
  <div className="flex flex-1 items-center px-3 pb-6">
    <Skeleton type="text" className="mx-4 my-2 h-[16px] w-[100px]" />
    <Skeleton type="text" className="mx-4 my-2 h-[16px] w-[150px]" />
  </div>
);

export const DetailsPageSkeleton = () => {
  const { config } = useConfigContext();
  return (
    <>
      {!config.webfeatures?.['nextgenui-default'] && (
        <Skeleton
          type="text"
          className="h-[40px] w-full rounded-none bg-prominence-50"
        />
      )}
      <div className="flex flex-1 bg-neutral-200">
        <div className="l-page 2xl:container">
          <BradcrumbSkeleton />

          <div className="flex flex-col gap-8 lg:flex-row lg:gap-16">
            <div className="aspect-video w-full animate-pulse rounded-xl bg-neutral-400 object-cover lg:mx-3 lg:max-w-[320px]" />
            <div className="flex flex-1 flex-col gap-6 lg:px-4">
              <Skeleton type="title" className="h-[44px] w-[300px]" />
              <Skeleton type="text" />
              <Skeleton type="button" className="mt-auto" />
            </div>
          </div>
        </div>
      </div>
      <div className="lg:l-page flex-1 2xl:container">
        <div className="flex flex-col gap-8 lg:flex-row lg:gap-x-16">
          <div className="flex w-full flex-row gap-3 overflow-x-auto px-6 py-4 text-neutral-500 lg:mx-3 lg:w-[320px] lg:min-w-[320px] lg:flex-col lg:gap-2 lg:overflow-visible lg:p-0">
            <Skeleton type="button" className="w-full" />
            <Skeleton type="button" className="w-full" />
            <Skeleton type="button" className="w-full" />
            <Skeleton type="button" className="w-full" />
          </div>

          <div className="flex flex-1 flex-col gap-y-6 px-3 pb-6 md:gap-y-4 md:pb-0 lg:px-0 ">
            <Skeleton type="text" className="mx-4 h-[30px] w-[200px]" />
          </div>
        </div>
      </div>
    </>
  );
};
